export default "__VITE_ASSET__Crl7lLOE__"